import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { AppStateService } from 'src/app/services/app-state.service';

@Component({
  selector: 'app-send-documents-photo',
  templateUrl: './send-documents-photo.component.html',
  styleUrls: ['./send-documents-photo.component.scss']
})
export class SendDocumentsPhotoComponent implements OnInit {

  sended: boolean;
  form: FormGroup;

  constructor(private appState: AppStateService, private router: Router, private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      telefone: ['', [Validators.required, Validators.minLength(9)]]
    });
   }

  ngOnInit() {
  }

  next() {
    this.appState.setLoading(true).then(() => {
      setTimeout(() => {
        this.sended = true;
        this.appState.setLoading(false);
      }, 3000);
    });
  }

  documentsSended() {
    this.appState.setLoading(true).then(() => {
      setTimeout(() => {
        this.router.navigate(['accept-contract']);
        this.appState.setLoading(false);
      }, 3000);
    });
  }

  dontReceiveLink() {

  }

}
